// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Playing-card {
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 4px;
  -webkit-backface-visibility: hidden; /*fix for jumping*/
}

.Playing-card:hover {
  /*box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);*/
}`, "",{"version":3,"sources":["webpack://./reactjs/react-playing-cards-local/src/PlayingCard/Hand/PlayingCard/PlayingCard.css"],"names":[],"mappings":"AAAA;EACE,kEAAkE;EAClE,+CAA+C;EAC/C,kBAAkB;EAClB,mCAAmC,EAAE,kBAAkB;AACzD;;AAEA;EACE,0EAA0E;AAC5E","sourcesContent":[".Playing-card {\n  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);\n  transition: all 0.3s cubic-bezier(.25,.8,.25,1);\n  border-radius: 4px;\n  -webkit-backface-visibility: hidden; /*fix for jumping*/\n}\n\n.Playing-card:hover {\n  /*box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);*/\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
